import React, { useState, useContext } from "react";
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DateRangePickerComponent from '../../components/DateRangePickerComponent';
import TextComponent from '../../components/TextComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import { CubeJSContext } from '../../context/CubeJSProvider';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { setHours, setMinutes, setSeconds, setMilliseconds, format } from 'date-fns'

const applyFilter = (query, storeFilter) => {
  let storeCodeFilterObj = {
    member: "MvOrderTransactions.shipFromStoreCode",
    operator: "equals",
    values: storeFilter
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }

  let membershipCodeFilterObj = {
    member: "Users.membershipCode",
    operator: "set"
  }

  query = {
    ...query,
    filters: (query.filters || []).concat(membershipCodeFilterObj)
  }

  return query
}

const DiscountBreakdownByMemberQuery = (storeFilter, startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  if(startDateFilter == null && endDateFilter == null){
    startDateFilter = new Date()
    startDateFilter.setHours(0,0,0,0);
    endDateFilter = new Date()
    endDateFilter.setHours(23,59,59,999);
  }
  else if(startDateFilter == null){
    startDateFilter = setHours(endDateFilter, 0)
    startDateFilter = setMinutes(startDateFilter, 0)
    startDateFilter = setSeconds(startDateFilter, 0)
    startDateFilter = setMilliseconds(startDateFilter, 0)
  }
  else if (endDateFilter == null){
    endDateFilter = setHours(startDateFilter, 23)
    endDateFilter = setMinutes(endDateFilter, 59)
    endDateFilter = setSeconds(endDateFilter, 59)
    endDateFilter = setMilliseconds(endDateFilter, 999)
  }
  let item = {
    name: t('page.fnb.discountBreakdownByMemberPage.name'),
    tableHeaders: {
      "MvOrdersSummary.shipFromStoreCode": { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.shipFromStoreCode'), type: "string" },
      "MvOrderTransactions.discountCode":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.discountCode'), type: "string" },
      "MvOrderTransactions.discountNameEnHk":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.discountNameEnHk'), type: "string" },
      "MvOrderTransactions.discountNameZhHk":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.discountNameZhHk'), type: "string" },
      "MvOrderTransactions.sumLineTotal":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.lineTotal'), type: "number" },
      "MvOrderTransactions.sumQuantity":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.quantity'), type: "number" },
      "Users.membershipCode":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.membershipCode'), type: "string" },
      "MvOrdersSummary.referenceNumber":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.referenceNumber'), type: "string" },
      "Users.firstName":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.firstName'), type: "string" },
      "Users.phone":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.phone'), type: "string" },
      "Users.userPreferDistrict":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.userPreferDistrict'), type: "string" },
      "CustomerRanks.code":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.code'), type: "string" },
      "UserLoyaltyPointBalances.rankExpireAt": { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.rankExpireAt'), type: "date" },
      "MvOrdersSummary.ordersCompletedAt":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.ordersCompletedAt'), type: "dateTime" },
      "MvOrdersSummary.sumNetSales":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.sumNetSales'), type: "number" },
      "MvOrderTransactions.couponRedeemablePoint":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.couponRedeemablePoint'), type: "number" },
      "MvOrderTransactions.couponRedeemablePrice":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.couponRedeemablePrice'), type: "number" },
      "MvOrderTransactions.couponTokensCreatedAt":  { name: t('page.fnb.discountBreakdownByMemberPage.tableHeader.couponTokensCreatedAt'), type: "dateTime" }
    },
    grid: {xs: 12},
    export: { allowExport: true, filename: 'discount_breakdown_by_member_export_' + format(startDateFilter, 'yyyyMMddHHmmss') + 
      '_' + format(endDateFilter, 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.mvOrdersSummary.DiscountBreakdownByOrder.query,
    "timeDimensions": [
      {
        "dimension": "MvOrdersSummary.ordersCompletedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      }
    ],
  }
  query = applyFilter(query, storeFilter)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const DiscountBreakdownByMemberPage = () => {
  const { t } = useTranslation();
  const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeFilter, setStoreFilter ] = useState([]);
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);

  const { item, result }  = DiscountBreakdownByMemberQuery(storeFilter, startDateFilter, endDateFilter, refresh1, setRefresh1)

  const refresh = () => {
    setRefresh1(true)
    setPage(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.discountBreakdownByMemberReport')} />,
    <Dashboard>
      <MultiSelectComponent id={"store_code_filter"} state={storeFilter} pageChangerArr={[setPage]}
          stateChanger={setStoreFilter} textLabel={t('page.fnb.discountBreakdownByMemberPage.filter.store.name')} selectArray={storeCodeSelect}/>
      <DateRangePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter}  pageChangerArr={[setPage]}
        startDateLabel={t('page.fnb.discountBreakdownByMemberPage.filter.orderCompletedAt.startDate')} 
        toLabel={t('page.fnb.discountBreakdownByMemberPage.filter.orderCompletedAt.to')} 
        endDateLabel={t('page.fnb.discountBreakdownByMemberPage.filter.orderCompletedAt.endDate')}/>
    </Dashboard>
    ,
    <Dashboard>
      <TextComponent title={t('component.text.historical')} xs={12} />
      <TableComponent item={item} result={result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}/>
    </Dashboard>
  ]) 
};

export default DiscountBreakdownByMemberPage;